const SelectCampaign = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-6">Create Campaign</h2>

      <div className="mt-4">
        {["campaignName", "couponCode", "startDate", "endDate"].map(
          (field) => (
            <div key={field} className="mb-4">
              <label
                htmlFor={field}
                className="block text-sm font-medium text-gray-700"
              >
                {field
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type={
                  field.includes("Date") ? "datetime-local" : "text"
                }
                min={
                  field.includes("Date")
                    ? new Date().toISOString().slice(0, 16)
                    : undefined
                }
                id={field}
                name={field}
                value={formData[field] ?? ""}
                onChange={handleInputChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SelectCampaign;
